import React, { Component } from 'react';
import { connect } from 'react-redux';
import template from '../../templates/PageLayout/PageLayout.rt';
import { cleanProps } from '../../utilities/props.js';

const fullPageRoutes = ["/wizard", "/pricing"];

function mapStateToProps(state, props) {
  const { popups, pricingPreset, featureInclusion, newStone, newInstallationGroupItem, newFeature } = state;
  const fullPage = fullPageRoutes.some(url => props.location.pathname.includes(url));
  return {
    contentWrapperCss: function (props) {
      if (fullPage) {
        // we can't use case, because we have sub routes, such as wizard/1
        return props.location.pathname.includes("/pricing")
          ? 'app-content-wrapper-pricing scrollbar3 app-content-wrapper--fullpage'
          : 'app-content-wrapper-adj app-content-wrapper--fullpage'
      }
      switch (props.location.pathname) {
        case "/newaccount":
          return "new-account-content";
        case "/jobboard":
        case "/fabricators":
        case "/customers":
        case "/employees":
        case "/stores":
          return "job-board-content";
        case "/edit-templates":
          return "app-content-wrapper-adj app-content-wrapper--fullpage app-content-wrapper2--small";
        case '/filters':
        case '/filterGroupItems':
        case '/filtersAssignToStones':
        case '/sku-filters':
        case '/sku-filterGroupItems':
        case '/taxes':
        case '/discounts':
        case '/wizard':
        case '/features-setup':
        case "/agent":
        case "/sites":
        case "/visualizer-management":
        case "/email-templates":
          return 'app-content-wrapper-adj app-content-wrapper--fullpage';
        case '/filtersAssignToFeatures':
          return "app-content-wrapper--with-top-panel";
        case '/newscope':
        case '/assign-sku-filterGroupItems':
          return "app-content-wrapper--with-top-panel-newscope";
        case "/login":
        case "/":
        case "/stones/pricing":
        case "/featureSelection":
          return "app-content-wrapper-adj";
        default:
          return "";
      }
    }(props),
    contentWrapperInternalClass: function (props) {
      if (fullPage) {
        return props.location.pathname.includes("/wizard")
          ? 'app-content-wrapper2 app-content-wrapper2--scrollable'
          : 'app-content-wrapper2--fullscreen'
      }
      switch (props.location.pathname) {
        case "/stones/pricing":
          return "app-content-wrapper2 app-content-wrapper2-adj app-content-wrapper2--small";
        case "/visualizer-management":
          return "app-content-wrapper2 app-content-wrapper2-adj app-content-wrapper2--no-header";
        case '/filters':
        case '/filterGroupItems':
        case '/filtersAssignToFeatures':
        case '/filtersAssignToStones':
        case '/taxes':
        case '/sku-filters':
        case '/sku-filterGroupItems':
          return 'filters-body';
        case '/featureSelection':
          return 'app-content-wrapper2 feature-inclusion-content-wrapper';
        case '/features':
          return 'app-content-wrapper2 app-content-wrapper2--features';
        case '/wizard':
        case '/features-setup':
        case "/agent":
        case "/fabricators":
        case "/purchase":
          return 'app-content-wrapper2 app-content-wrapper2--fullscreen';
        case '/newscope':
          return 'app-content-wrapper2 app-content-wrapper2-adj app-content-wrapper2--net';
        case '/discounts':
          return "app-content-wrapper2 app-content-wrapper2--scrollable app-content-wrapper2--scrollable-always-y app-content-wrapper2-adj"
        default:
          return "app-content-wrapper2 app-content-wrapper2-adj";
      }
    }(props),
    headerClass: function (props) {
      switch (props.location.pathname) {
        case "/stones/pricing":
          return "app-header app-header-adj";
        case '/filters':
        case '/filterGroupItems':
        case '/filtersAssignToFeatures':
        case '/filtersAssignToStones':
        case '/sku-filters':
        case '/sku-filterGroupItems':
        case '/assign-sku-filterGroupItems':
        case '/featureSelection':
        case '/taxes':
          return 'app-header app-header-adj';
        default:
          return "app-header";
      }
    }(props),
    popups,
    pricingPreset,
    featureInclusion,
    newStone,
    newInstallationGroupItem,
    newFeature
  };
}

const DefaultLayoutComponent = (props) => {
  const validProps = cleanProps(props);
  return (
    <div {...validProps}></div>
  );
};

export const LayoutComponents = {
  pageHeader: DefaultLayoutComponent,
  pageMenu: DefaultLayoutComponent,
  contentHeader: DefaultLayoutComponent,
  content: DefaultLayoutComponent,
  contentFooter: DefaultLayoutComponent,
  pageFooter: DefaultLayoutComponent
};

export class PageLayoutControl extends Component {
  scrollContainer = null;
  setScrollContainer = (node) => {
    this.scrollContainer = node;
  }
  state = {
    showPricingPreset: false
  }
  hidePricingPreset = () => {
    this.setState({ showPricingPreset: false });
  }

  showPricingPreset = (preset) => {
    this.setState({ showPricingPreset: true });
  }

  render = template
}

const PageLayout = connect(mapStateToProps)(PageLayoutControl);

export default PageLayout;
